<template>
  <div class="switch-wrapper" :style="customStyle">
    <span class="text-before" v-if="textBefore">{{textBefore}}</span>
    <label class="switch">      
      <span v-bind:class="['slider round', {'disabled': disabled}, {'checked' : checked }]" @click="onClick"></span>
    </label>
    <span class="text-after" v-if="textAfter">{{textAfter}}</span>
  </div>
</template>

<script>
  export default {
    name: "cc-switcher",
    props: {
      value: {
        type: [String, Number, Function],
        required: false,
        default: null
      },
      checked: {
        type: [Boolean, String],
        required: false,
        default: false
      },
      disabled: {
        type: [Boolean, String],
        required: false,
        default: false
      },
      textBefore: {
        type: String,
        required: false
      },
      textAfter: {
        type: String,
        required: false
      },
      customStyle: {
        type: String,
        required: false
      },
    },

    data(){
      return {
        uid: this._uid,
      }
    },

    methods: {
      onClick: function() {
        if(!!this.disabled === false ) {              
          this.$emit('toggle', !this.checked, this.value);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

  .switch-wrapper {
    text-align: center;
    margin-top: 5px;
  }

  .text-before {
    display: inline-block;
    vertical-align: middle;
  }

  .text-after {
    display: inline-block;
    vertical-align: middle;
  }

  /* The switch - the box around the slider */
  .switch {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 26px;
    vertical-align: middle;
  }

  /* Hide default HTML checkbox */
  .switch input {
    display:none;
    // display:block;
    // position: absolute;
    // top: -25px;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #a8a8a8;
    -webkit-transition: .4s;
    transition: .4s;
    width: 40px;
    height: 24px;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    top: 4px;
    left: 4px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
  }

  .checked.slider {
    background-color: #2196F3;
  }

  .slider:focus {
    box-shadow: 0 0 1px #2196F3;
  }

  .checked.slider:before {
    -webkit-transform: translateX(16px);
    -ms-transform: translateX(16px);
    transform: translateX(16px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.disabled {
    opacity: 0.4;
  }

  .slider.round:before {
    border-radius: 50%;
  }

</style>


// WEBPACK FOOTER //
// src/components/common/switcher/v1/Switcher.vue